import {pushAnalyticsEvent} from '../../organisms/Analytics';
import {NEW_CYBERSOURCE_PAYMENT_FORM} from '../../../consts';

export function pushFormTrackingEvent(formField) {
    pushAnalyticsEvent({
        interactionName: 'form tracking',
        formName: NEW_CYBERSOURCE_PAYMENT_FORM,
        formField
    });
}
